import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('email'),
    descriptionForUser: defineMessage('you_can_change_your_email_address_up_to_five_times'),
    descriptionForAdmin: defineMessage('to_change_your_email_ad_r_customer_support_team'),
    descriptionForAdminRequested: defineMessage('weve_sent_a_request_to__ail_address_to_newemail'),
    buttonChange: defineMessage('change'),
    buttonContactSupport: defineMessage('contact_support_1'),
    buttonCancel: defineMessage('cancel_email_change'),
    toastCancelled: defineMessage('the_email_change_has_been_cancelled'),
};
